// extracted by mini-css-extract-plugin
export var header = "home-module--header--yqOgg";
export var perfil = "home-module--perfil--sloB0";
export var corpo = "home-module--corpo--fgJq5";
export var social = "home-module--social--EMCb2";